import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function Breadcrumbs({ breadcrumbs, className, onNavigate }: Props) {
  return (
    <div className={classNames(styles.breadcrumbs, className)}>
      {breadcrumbs.map(({ name, click, to, icon }, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <React.Fragment key={index}>
            {to ? (
              <Link
                className={classNames(styles.breadcrumb, styles.clickable, {
                  [styles.current]: isLast,
                })}
                to={to}
                onClick={(e) => {
                  if (
                    !e.ctrlKey &&
                    !e.metaKey &&
                    !e.shiftKey &&
                    e.button === 0
                  ) {
                    onNavigate?.();
                  }
                }}
              >
                {icon && <span className={styles.icon}>{icon}</span>}
                {name}
              </Link>
            ) : (
              <span
                className={classNames(styles.breadcrumb, {
                  [styles.clickable]: !!click,
                  [styles.current]: isLast,
                })}
                onClick={click}
              >
                {icon && <span className={styles.icon}>{icon}</span>}
                {name}
              </span>
            )}
            {!isLast && <span className={styles.separator}>{">"}</span>}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export { Breadcrumbs };
